module.exports = __webpack_public_path__ + "static/media/traffic.44dab6e8.png";